










import Vue from 'vue'
import { nl2br, autoLink, adjustDateToJp } from '@/utils'
export default Vue.extend({
  name: 'NewsContent',
  props: {
    date: {
      type: String,
      required: true
    },
    image: {
      type: [String, Boolean],
      required: false,
      default: ''
    },
    content: {
      type: String,
      required: true
    }
  },
  computed: {
    adjustDate(): string {
      return adjustDateToJp(this.date)
    }
  },
  methods: {
    formatContent(text: string) {
      return autoLink(nl2br(text), '_blank')
    }
  }
})
